module.exports = (obj)->
  return obj unless obj?
  JSON.parse(JSON.stringify(obj))



/** WEBPACK FOOTER **
 ** ./src/utils/clone.coffee
 **/